export const randomFixedInt = (length) => {
    const { random, floor } = Math
    const min = 10 ** (length - 1)
    const max = min * 9
    return floor(min + random() * max)
}

export const createUniqueId = () => {
    const date = new Date()
    const time = date.getTime()
    const randomNumber = randomFixedInt(4)
    return `${time}_${Math.floor(time / randomNumber)}`
}

export const groupBy = (objectArray, property) => objectArray.reduce((acc, obj) => {
    const key = obj[property]
    if (!acc[key]) {
        acc[key] = []
    }
    acc[key].push(obj)
    return acc
}, {})

export const sortBy = (arr, attribute) => {
    const compare = (a, b) => {
        if (a[attribute] < b[attribute]) { return -1 }
        if (a[attribute] > b[attribute]) { return 1 }
        return 0
    }
    return [].concat(arr).sort(compare)
}

const mergeNumbers = (numA, numB) => {
    const numAVal = numA || 0
    const numBVal = numB || 0
    return numAVal + numBVal
}
const mergeStrings = (textA, textB) => textB || textA
const mergeMixedValues = (keyObject, values) => {
    switch (typeof keyObject) {
        case 'number': {
            return mergeNumbers(...values)
        }
        case 'string': {
            return mergeStrings(...values)
        }
        case 'object': {
            return mergeObjects(...values) // eslint-disable-line no-use-before-define
        }
        default: {
            return undefined
        }
    }
}
export const mergeObjects = (objA, objB) => {
    const sumObjects = {}
    const mergedObj = {
        ...objA,
        ...objB,
    }
    Object.keys(mergedObj).map((key) => {
        const oldValue = objA[key]
        const newValue = objB[key]
        const valueTypesDiffer = typeof oldValue !== typeof newValue
        const oldValueIsUndefined = typeof oldValue === 'undefined'
        const newValueIsUndefined = typeof newValue === 'undefined'

        if (newValue === false) {
            return false
        }
        if (oldValueIsUndefined) {
            sumObjects[key] = newValue
        } else
        if (newValueIsUndefined) {
            sumObjects[key] = oldValue
        } else
        if (valueTypesDiffer) {
            sumObjects[key] = newValue
        } else {
            sumObjects[key] = mergeMixedValues(mergedObj[key], [oldValue, newValue])
        }
        return true
    })
    return sumObjects
}
